import React from 'react';
import {supportedLocales} from '../../../config/i18n';
import {NavLink} from 'react-router-dom';
import {useLang} from '../../../config/TranslationProvider';

const LanguageSwitcher = () => {
    const {setLang} = useLang();

    const handleLanguage = (e, code) => {
        e.preventDefault();
        setLang(code);
    };

    return (
        <ul className="language-menu">
            {Object.keys(supportedLocales).map(code => (
                <li key={code}>
                    <NavLink to="/" onClick={e => handleLanguage(e, code)} aria-label={'language-' + code}>
                        {code.toUpperCase()}
                    </NavLink>
                </li>
            ))}
        </ul>
    );
};

export default LanguageSwitcher;
